import { buildOrderUrl } from '@/helpers/api-url-builder';

export const orderService = {
  getOrders,
  getOrderById
};


function getOrders(){
  const token = localStorage.getItem("token");
  const requestOptions = {
    method: 'GET',
    headers: {
    'Accept': 'application/json',
    'Authorization': token,
    }
  };
  return fetch(buildOrderUrl(), requestOptions)
    .then(response => response.json()
  );
}

function getOrderById(id){
  const token = localStorage.getItem("token");
  const requestOptions = {
    method: 'GET',
    headers: {
    'Accept': 'application/json',
    'Authorization': token,
    }
  };
  return fetch(buildOrderUrl(id), requestOptions)
    .then(response => response.json()
  );
}